export const aside = {
    width: { xs: '100%', lg: 288 },
    flexShrink: 0,
};

export const card = {
    background: 'linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.015) 100%)',
    border: '1px solid rgba(187,188,188,0.14)',
    borderRadius: '22px',
    p: 2.5,    // fix 1 — 16px → 20px
};

export const avatar = {
    height: 48,
    width: 48,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.125rem',
    fontWeight: 700,
    background: 'linear-gradient(135deg, #0078FF, #00D7FF)',
    color: '#fff',
    flexShrink: 0,
};

export const displayName = {
    fontWeight: 600,
    color: 'var(--ecal-white)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

export const persona = {
    fontSize: '0.75rem',
    color: 'var(--ecal-lightgrey)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

export const nav = {
    mt: 2.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.25,
};

export const navLink = (active) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    px: '9.6px',    // fix 3 — was 8px (px:1)
    py: '8.8px',    // fix 3 — was 7px (py:0.875) → 40px height
    borderRadius: '12px',
    fontSize: '0.92rem',   // fix 4 — was 0.9375rem (15px)
    color: active ? 'var(--ecal-white)' : 'var(--ecal-lightgrey)',
    background: active     // fix 2 — gradient on active
        ? 'linear-gradient(90deg, rgba(0,120,255,0.20), rgba(0,215,255,0.08))'
        : 'transparent',
    border: 'none',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left',
    transition: 'background 0.18s ease, color 0.18s ease',
    '&:hover': {
        background: 'rgba(0,120,255,0.10)',
        color: 'var(--ecal-white)',
    },
});
